import { useState, useEffect } from 'react';
import { getCloudinaryPathWithCache } from '~/utils';

export function useCachedFile(url, transformation) {
    const [cachedUrl, setCachedUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadCachedFile = async () => {
            if (!url) {
                setCachedUrl('');
                return;
            }

            setLoading(true);
            setError(null);

            try {
                const result = await getCloudinaryPathWithCache(url, transformation);
                setCachedUrl(result);
            } catch (err) {
                console.warn('Failed to load cached file:', err);
                setError(err);
                // Fallback para URL original
                setCachedUrl(url);
            } finally {
                setLoading(false);
            }
        };

        loadCachedFile();
    }, [url, transformation]);

    return { cachedUrl, loading, error };
}
